import React from "react";
import PropTypes from "prop-types";
import { pure } from "recompose";
import styles from "./ThreeLevelInfo.scss";
import classnames from "classnames";

function ThreeLevelInfo({ firstLevel, secondLevel, thirdLevel }) {
  return (
    <div className={classnames("wbkv9-ThreeLevelInfo", "threeLevelInfo", styles.container)}>
      {firstLevel && <div className={styles.firstLevel}>{firstLevel}</div>}
      {secondLevel && <div className={styles.secondLevel}>{secondLevel}</div>}
      {thirdLevel && <div className={styles.thirdLevel}>{thirdLevel}</div>}
    </div>
  );
}

//TODO: Correct proptypes
// ThreeLevelInfo.propTypes = {
//   firstLevel: PropTypes.string,
//   secondLevel: PropTypes.string,
//   thirdLevel: PropTypes.string,
// };

export default pure(ThreeLevelInfo);
